import ThemeProvider from './ThemeProvider.tsx';

export default ThemeProvider;